export default function formatarData(data, showTime = true) {
  const dia = data.getDate() < 10 ? `0${data.getDate()}` : data.getDate();
  const mes = data.getMonth() + 1 < 10 ? `0${data.getMonth() + 1}` : data.getMonth() + 1;
  const ano = data.getFullYear();
  const horas = data.getHours();
  const minutos = data.getMinutes() < 10 ? `0${data.getMinutes()}` : data.getMinutes();
  return `${dia}/${mes}/${ano}${showTime ? ` - ${horas}:${minutos}` : ``}`;
}
